import { Box, IconButton, Typography } from "@mui/material";
import { ReactNode } from "react";

type SwitcherInputsProps = {
    renderDefaultInput: ReactNode;
    renderAlternativeInput: ReactNode;
    defaultIcon: ReactNode;
    alternativeIcon: ReactNode;
    defaultLabel: string,
    alternativeLabel: string,
    inputMode: "default" | "alternative" | null;
    toggleInputMode: (inputMode: "default" | "alternative" | null) => void;
};
export const SwitcherInputs = ({ renderDefaultInput, renderAlternativeInput, defaultIcon, alternativeIcon, defaultLabel, alternativeLabel, inputMode, toggleInputMode }: SwitcherInputsProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                border: inputMode ? "none" : "1px solid",
                borderColor: "rgba(0, 0, 0, 0.23)",
                borderRadius: 1,
                padding: inputMode ? 0 : 1,
                overflow: inputMode ? "visible" : "hidden",
                width: inputMode ? "100%" : "fit-content",
                minHeight: "57px",
            }}
        >
            <IconButton
                size="small"
                onClick={() => toggleInputMode(inputMode === "default" ? "alternative" : "default")}
                sx={{
                    width: inputMode === "alternative" ? 0 : "90px",
                    height: 36,
                    borderRadius: 1.5,
                    opacity: inputMode === "alternative" ? 0 : 1,
                    padding: inputMode === "alternative" ? 0 : undefined,
                    pointerEvents: inputMode === "alternative" ? "none" : "auto",
                    minWidth: 0,
                    flexShrink: 0,
                    alignSelf: "center",
                    transform: inputMode === "alternative" ? "translateX(30px)" : "translateX(0)",
                    color: "action.active",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        backgroundColor: "action.hover",
                        transform: inputMode === "alternative" ? "translateX(30px)" : "scale(1.05)",
                    },
                }}
            >
                {defaultIcon}
            <Typography variant="body2" sx={{ marginLeft: 1 }}>{defaultLabel}</Typography>
            </IconButton>

            <IconButton
                size="small"
                onClick={() => toggleInputMode(inputMode === "alternative" ? "default" : "alternative")}
                sx={{
                    width: inputMode === "default" ? 0 : "90px",
                    height: 36,
                    borderRadius: 1.5,
                    opacity: inputMode === "default" ? 0 : 1,
                    padding: inputMode === "default" ? 0 : undefined,
                    pointerEvents: inputMode === "default" ? "none" : "auto",
                    minWidth: 0,
                    flexShrink: 0,
                    alignSelf: "center",
                    transform: inputMode === "default" ? "translateX(30px)" : "translateX(0)",
                    color: "action.active",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        backgroundColor: "action.hover",
                        transform: inputMode === "default" ? "translateX(30px)" : "scale(1.05)",
                    },
                }}
            >
                {alternativeIcon}
                <Typography variant="body2" sx={{ marginLeft: 1 }}>{alternativeLabel}</Typography>
            </IconButton>

            <Box
                sx={{
                    width: inputMode ? "1px" : 0,
                    height: 24,
                    backgroundColor: "divider",
                    opacity: inputMode ? 0.6 : 0,
                    marginLeft: inputMode ? 1 : 0,
                    flexShrink: 0,
                    alignSelf: "center",
                    transition: "all 0.3s ease",
                }}
            />

            <Box
                sx={{
                    flex: 1,
                    opacity: inputMode ? 1 : 0,
                    transform: inputMode ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.3s ease 0.1s, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.1s",
                    pointerEvents: inputMode ? "auto" : "none",
                    minWidth: 0,
                    alignSelf: "stretch",
                    ml: inputMode ? 2 : 0,
                }}
            >
                {inputMode === "default" && renderDefaultInput}
                {inputMode === "alternative" && renderAlternativeInput}
            </Box>
        </Box>
    );
};